import styled from '@emotion/styled';
import React from 'react';

import type { LensSpanProps } from '../../types';
import { getColorValue, getSize, type SizeProp } from '../../utilities';

const defaultIconSize = 3;

const IconWrapper = styled.span<IconProps>`
  display: block;
  color: ${props => getColorValue(props.color)};

  & > svg,
  & > img {
    display: block;
    ${props => getSize('width', props.size)};
    ${props => getSize('height', props.size)};
  }

  // TODO: remove data-testid once all icons are using ADS
  [data-testid='ads-refreshed-icon'] {
    display: block;
    ${props => getSize('width', props.size)};
    ${props => getSize('height', props.size)};

    svg {
      padding: 8%;
      height: 100%;
      width: 100%;
    }
  }
`;

type IconProps = {
  size?: SizeProp;
  altText?: string;
  icon?: React.ReactNode;
  color?: string;
};

const Icon = ({
  altText,
  icon,
  color = 'body',
  size = defaultIconSize,
  ...props
}: IconProps &
  React.ComponentProps<typeof IconWrapper> &
  Omit<
    LensSpanProps,
    keyof IconProps & React.ComponentProps<typeof IconWrapper>
  >) => {
  const ref = React.useRef(null);

  return (
    <IconWrapper
      ref={ref}
      aria-label={altText}
      color={color}
      size={size}
      {...props}
    >
      {icon}
    </IconWrapper>
  );
};

export default Icon;
